export enum SalarySystemType {
  PER_DIRECT_DISTANCE = 'PerDirectDistance',
  PER_ROUTE_DISTANCE = 'PerRouteDistance',
  PER_DIRECT_DISTANCE_SEGMENT = 'PerDirectDistanceSegment',
  PER_ROUTE_DISTANCE_SEGMENT = 'PerRouteDistanceSegment'
}
